import type {
  WebVitalsConfig,
  MetricsConfig,
  PerformanceMonitorConfig,
} from "./types";

export const DEFAULT_WEB_VITALS_CONFIG: WebVitalsConfig = {
  enabled: true,
  sampleRate: 1.0,
  reportThresholds: {
    CLS: 0.1,
    INP: 200,
    FCP: 1800,
    LCP: 2500,
    TTFB: 800,
  },
};

export const DEFAULT_METRICS_CONFIG: MetricsConfig = {
  enabled: true,
  maxMetrics: 1000,
  retentionPeriod: 24 * 60 * 60 * 1000, // 24 hours
  aggregationWindow: 5 * 60 * 1000, // 5 minutes
};

export const DEFAULT_PERFORMANCE_MONITOR_CONFIG: PerformanceMonitorConfig = {
  enabled: true,
  sampleRate: 1.0,
  thresholds: {
    "navigation.load": 3000,
    "navigation.domContentLoaded": 2000,
    "resource.large": 5000,
    "layout-shift": 0.1,
  },
  alertThresholds: {
    "navigation.load": 5000,
    "navigation.domContentLoaded": 4000,
    "resource.large": 10000,
    "layout-shift": 0.25,
  },
};

export class PerformanceConfig {
  private static instance: PerformanceConfig;
  private webVitalsConfig: WebVitalsConfig;
  private metricsConfig: MetricsConfig;
  private performanceMonitorConfig: PerformanceMonitorConfig;

  private constructor() {
    this.webVitalsConfig = { ...DEFAULT_WEB_VITALS_CONFIG };
    this.metricsConfig = { ...DEFAULT_METRICS_CONFIG };
    this.performanceMonitorConfig = { ...DEFAULT_PERFORMANCE_MONITOR_CONFIG };
  }

  static getInstance(): PerformanceConfig {
    if (!PerformanceConfig.instance) {
      PerformanceConfig.instance = new PerformanceConfig();
    }
    return PerformanceConfig.instance;
  }

  getWebVitalsConfig(): WebVitalsConfig {
    return { ...this.webVitalsConfig };
  }

  setWebVitalsConfig(config: Partial<WebVitalsConfig>): void {
    this.webVitalsConfig = { ...this.webVitalsConfig, ...config };
  }

  getMetricsConfig(): MetricsConfig {
    return { ...this.metricsConfig };
  }

  setMetricsConfig(config: Partial<MetricsConfig>): void {
    this.metricsConfig = { ...this.metricsConfig, ...config };
  }

  getPerformanceMonitorConfig(): PerformanceMonitorConfig {
    return { ...this.performanceMonitorConfig };
  }

  setPerformanceMonitorConfig(config: Partial<PerformanceMonitorConfig>): void {
    this.performanceMonitorConfig = {
      ...this.performanceMonitorConfig,
      ...config,
    };
  }

  reset(): void {
    this.webVitalsConfig = { ...DEFAULT_WEB_VITALS_CONFIG };
    this.metricsConfig = { ...DEFAULT_METRICS_CONFIG };
    this.performanceMonitorConfig = { ...DEFAULT_PERFORMANCE_MONITOR_CONFIG };
  }
}
